import React from 'react';
import Additional_Earning from './Additional_Earning';
import '../../../CommonCSS/SocietyCSS.css'

const Additional_EarningApp = () => {
  return (
    // <div className="App">
    //   <Common_Mst />
    // </div>
    <div className="app-wrapper">
      <div className="form-container">
        <div className='card' style={{borderRadius: '8px'}}>
          <div className="card-header-css" style={{borderRadius: '8px', textAlign: 'center' }} >
            <h5>Additional Earnings</h5>
          </div>  
        </div>
        <Additional_Earning/>
      </div>
    </div >
  );
};

export default Additional_EarningApp;
